import { getAxiosInstance } from "../utils/apiClient";
import { getTokens } from "../utils/tokens";

const axiosInstance = getAxiosInstance();

export const getLinkTrackingAPI = (creatorId) => {
    return new Promise((resolve, reject) => {
        const tokens = getTokens();
        axiosInstance
            .get(`/api/link-tracking/${creatorId}`, {
                headers: {
                    "Content-Type": "application/json",
                    [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
                    [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]: `Bearer ${tokens.firebase_token}`,
                    "ngrok-skip-browser-warning": "true",
                },
            })
            .then((res) => resolve(res.data))
            .catch((err) => reject(err?.response?.data || err));
    });
};

export const logLinkClickAPI = (link, creatorId) => {
    return new Promise((resolve, reject) => {
        const tokens = getTokens();
        axiosInstance
            .post(`/api/link-tracking/${creatorId}/click`, { link: link }, {
                headers: {
                    "Content-Type": "application/json",
                    [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
                    [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]:
                        `Bearer ${tokens.firebase_token}`,
                    "ngrok-skip-browser-warning": "true",
                },
            })
            .then((res) => resolve(res.data))
            .catch((err) => reject(err?.response?.data || err));
    });
};

export const getLinkTrackingStatsAPI = (creatorId, params = {}) => {
    return new Promise((resolve, reject) => {
        const tokens = getTokens();
        axiosInstance
            .get(`/api/link-tracking/${creatorId}/stats`, {
                params,
                headers: {
                    "Content-Type": "application/json",
                    [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
                    [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]: `Bearer ${tokens.firebase_token}`,
                    "ngrok-skip-browser-warning": "true",
                },
            })
            .then((res) => resolve(res.data))
            .catch((err) => reject(err?.response?.data || err));
    });
};
